import React, { useState, useEffect, useCallback } from "react";
import { equiposFabricacion } from "../constants/Constants";
import { getFullUsuarios } from "./ConnectDataBase";
import { EquiposFabricacion } from "../constants/Constants";

export async function getTimeForTeam(usuarios) {
  const cuentaPorEquipo = EquiposFabricacion.reduce((acc, equipo) => {
    acc[equipo] = 0;
    return acc;
  }, {});
  const NumeroPiedras = 3000;
  usuarios.forEach((usuario) => {
    const equipo = usuario.team;
    if (cuentaPorEquipo.hasOwnProperty(equipo)) {
      cuentaPorEquipo[equipo]++;
    } else {
      console.log(`Equipo no encontrado: ${equipo}`);
    }
  });

  Object.keys(cuentaPorEquipo).forEach((equipo) => {
    if (equipo === "Engastado") {
      cuentaPorEquipo[equipo] = NumeroPiedras; // Asignar el valor fijo de NumeroPiedras
    } else {
      cuentaPorEquipo[equipo] *= equipo === "Baños" ? 816 : 408;
    }
  });

  const resultadoArray = Object.entries(cuentaPorEquipo).map(
    ([team, minutes]) => ({
      team,
      minutes,
    })
  );

  // Definir el orden deseado
  const ordenDeseado = [
    "Sacador de fuego",
    "Engastado",
    "Pulido",
    "Baños",
    "Control de calidad",
  ];

  // Ordenar el array basado en el orden deseado
  const resultadoArrayOrdenado = resultadoArray.sort(
    (a, b) => ordenDeseado.indexOf(a.team) - ordenDeseado.indexOf(b.team)
  );

  return resultadoArrayOrdenado;
}
